export default "__VITE_ASSET__D4p8qNCZ__"